import { fetchQuotesApi, fetchDetailsQuoteApi } from './api'
import { POSTAL, DROPOFF, PICKUP } from '../assets/constant'

export const FETCH_QUOTES = 'FETCH_QUOTES';
export const SET_QUOTES = 'SET_QUOTES';
export const RESET_QUOTES = 'RESET_QUOTES';
export const REQUEST_QUOTES = 'REQUEST_QUOTES';
export const SET_POSTAL = 'SET_POSTAL';
export const SET_PICKUP = 'SET_PICKUP';
export const SET_DROPOFF = 'SET_DROPOFF';


export function resetQuotes() {
  return {
    type: RESET_QUOTES,
  };
}

export function setQuotes(quotes) {
  return {
    type: SET_QUOTES,
    payload: quotes
  };
}

function setPostal(postal) {
  return {
    type: SET_POSTAL,
    payload: postal
  };
}

function setDropoff(dropoff) {
  return {
    type: SET_DROPOFF,
    payload: dropoff
  };
}

function setPickup(pickup) {
  return {
    type: SET_PICKUP,
    payload: pickup
  };
}

function requestQuotes() {
   return {
    type: REQUEST_QUOTES,
  };
}

export function fetchQuotes(shipback_id, user_token) {
  return function (dispatch) {
    dispatch(requestQuotes())
    return fetchQuotesApi(shipback_id, user_token)
    .then(json => {
      dispatch(setQuotes(json))
    })
  }
}

export function fetchDetailsQuote(shipback_id, mode, user_token) {
  return function (dispatch) {
    dispatch(requestQuotes())
    return fetchDetailsQuoteApi(shipback_id, mode, user_token)
    .then(json => {
      switch(mode) {
        case DROPOFF:
          dispatch(setDropoff(json))
        case POSTAL:
          dispatch(setPostal(json))
        case PICKUP:
          dispatch(setPickup(json))
      }
    })
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/actions/quotes.js